import { useTranslation } from 'react-i18next';
import { ITransactionParameters } from '../../interface/transaction';
import { InvoiceableDurationStep, InvoiceableDurationStepValue } from '../../constants/constants';
import { useLanguage } from '../../context/LanguageContext';
import { ITransactionTypes } from '../../interface/transactionTypes';
import { Flex } from 'antd';
import { Heading, Paragraph, Text } from '../Ant';
import { ApplicationSettingsWrapper } from '../../assets/styles/components/settingsPopover.styled';

interface ITransactionSettins {
  transactionParameters: ITransactionParameters;
  transactionTypesDetails: ITransactionTypes;
}
const TransactionSetting = ({
  transactionParameters,
  transactionTypesDetails,
}: ITransactionSettins) => {
  const { t } = useTranslation();
  const { getAppLanguageCode } = useLanguage();
  const defaultTransactionTypeName =
    transactionTypesDetails?.translations?.find((t) => t.language === getAppLanguageCode())
      ?.nameTranslation ?? '-';
  const getInvoiceableDurationStepLabel = (step: InvoiceableDurationStep | undefined): string => {
    switch (step) {
      case InvoiceableDurationStep.SIX_MINUTES:
        return `${InvoiceableDurationStepValue.SIX_MINUTES} ${t('common:minuteShort')}`;
      case InvoiceableDurationStep.TWELVE_MINUTES:
        return `${InvoiceableDurationStepValue.TWELVE_MINUTES} ${t('common:minuteShort')}`;
      case InvoiceableDurationStep.FIFTEEN_MINUTES:
        return `${InvoiceableDurationStepValue.FIFTEEN_MINUTES} ${t('common:minuteShort')}`;
      case InvoiceableDurationStep.THIRTY_MINUTES:
        return `${InvoiceableDurationStepValue.THIRTY_MINUTES} ${t('common:minuteShort')}`;
      case InvoiceableDurationStep.NONE:
      default:
        return '-';
    }
  };

  const displayTransactionTypeSetting = () => {
    if (!transactionParameters?.transactionTypeInUse) {
      return t('transaction:notInUse');
    }
    if (transactionParameters?.transactionTypeRequired) {
      return t('transaction:required');
    } else {
      return t('transaction:optional');
    }
  };
  const transactionData = [
    {
      label: t('transaction:minimumBillablehours'),
      value: transactionParameters?.minimumInvoiceableDurationInHours ?? '-',
    },
    {
      label: t('transaction:transactionDurationStep'),
      value: getInvoiceableDurationStepLabel(
        transactionParameters?.invoiceableDurationStep as InvoiceableDurationStep,
      ),
    },
    {
      label: t('transaction:transactionType.transactionType'),
      value: displayTransactionTypeSetting(),
    },
    {
      label: t('transaction:defaultTransactionType'),
      value: transactionParameters?.transactionTypeInUse ? defaultTransactionTypeName : '-',
    },
  ];
  return (
    <Flex vertical gap={15} className="resizable-modal-scroll">
      <Flex vertical gap={10}>
        <Heading level={6} $fontsize="12px" $weight={500} $lineheight="18px" $color="subtitle">
          {t('common:profile.transactionParameters')}
        </Heading>
        <ApplicationSettingsWrapper vertical gap={10}>
          {transactionData.map((item) => (
            <Flex gap={2} key={item.label} justify="space-between" className="settings-item">
              <Paragraph
                data-testid="transaction-label"
                $fontsize="12px"
                $lineheight="20px"
                $color="title"
                $width="100%"
              >
                {item.label}
              </Paragraph>
              <Text
                data-testid="transaction-value"
                $fontsize="12px"
                $lineheight="18px"
                $color="title"
                $weight={600}
                className="whitespace-nowrap"
              >
                {item.value}
              </Text>
            </Flex>
          ))}
        </ApplicationSettingsWrapper>
      </Flex>
    </Flex>
  );
};

export default TransactionSetting;
